import { useRouter } from "next/router";

export const useCurrentHash = (): string | undefined => {
  const { asPath } = useRouter();

  const hash = asPath.split("#")[1];

  return hash ? hash : undefined;
};
